import { TableCell } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MyCheckBox from '../form/MyCheckBox'
import { setValueForm } from '../../../helpers/form/FormHelper'

const MyTableCheckBox = ({ id, checked, setChecked, isReturnValues = false }) => {

    const [checkedItem, setCheckedItem] = useState(false)

    // console.log('checkedItem, id', checkedItem)
    // console.log('checkedItem, id', checkedItem, id)

    useEffect(() => {
        isChecked()
    }, [checked])

    const isChecked = () => {
        let checkedTemp = false

        if (checked) {
            if (checked[id]) {
                checkedTemp = true
            }
        }

        setCheckedItem(checkedTemp)
    }

  return (
    <TableCell align='center' className='myTable__checkbox'>
        <MyCheckBox
            // value={false}
            value={checkedItem}
            // setValue={e => setValueForm(setChecked, id, e)}
            setValue={e => {
                if (isReturnValues) {
                    setChecked({
                        name: id, 
                        value: e
                    })
                } else {
                    setValueForm(setChecked, id, e)
                }
            }}
            // label
        />
    </TableCell>
  )
}

export default MyTableCheckBox